const seedProducts = [
  {
    id: "prd_1001",
    netsuiteSku: "WWG-TS-BLK",
    netsuiteTitle: "WWG Logo Tee (Black)",
    sku: "WWG-TS-BLK",
    name: "WWG Logo Tee",
    description: "Classic cotton tee with embroidered WWG crest.",
    pricing: {
      lastPurchaseCents: 2500,
      premierMemberCents: 2200,
      retailCents: 2500,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Clothing",
    language: "English",
    availability: "available",
    productType: "Clothing",
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    tags: ["apparel", "evergreen"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_1",
    variationIds: ["var_1", "var_2"],
    variations: [
      { id: "var_1", color: "Black", sizes: ["S", "M", "L", "XL"] },
      { id: "var_2", color: "Navy", sizes: ["S", "M", "L", "XL", "XXL"] },
    ],
    stock: 142,
    image: "/figma-products/shirt_1.jpg",
    createdAt: "2025-01-12T18:04:00Z",
    updatedAt: "2025-05-03T12:11:00Z",
  },
  {
    id: "prd_1002",
    netsuiteSku: "WWG-MUG-WHT",
    netsuiteTitle: "Ceramic Mug 12oz",
    sku: "WWG-MUG-WHT",
    name: "Ceramic Mug 12oz",
    description: "Dishwasher-safe ceramic mug.",
    pricing: {
      lastPurchaseCents: 1200,
      premierMemberCents: 1000,
      retailCents: 1200,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Drinkware",
    language: "English",
    availability: "available",
    productType: "Drinkware",
    storeAppCategories: ["Drinkware", "Accessories"],
    statusLabel: "Published",
    audiencePinCodes: ["PLA", "EME", "DIA"],
    tags: ["drinkware"],
    audienceGroupIds: ["aud_all", "aud_pin_gold"],
    primaryMediaId: "med_2",
    variationIds: [],
    stock: 58,
    image: "/figma-products/mug_1.jpg",
    createdAt: "2025-02-01T10:00:00Z",
    updatedAt: "2025-04-20T09:30:00Z",
  },
  {
    id: "prd_1003",
    netsuiteSku: "WWG-CAP-NAV",
    netsuiteTitle: "Structured Cap (Navy)",
    sku: "WWG-CAP-NAV",
    name: "Structured Cap",
    description: "Six-panel structured cap, adjustable strap.",
    pricing: {
      lastPurchaseCents: 1800,
      premierMemberCents: 1600,
      retailCents: 1800,
    },
    currency: "USD",
    status: "archived",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Clothing",
    language: "English",
    availability: "outofstock",
    productType: "Clothing",
    statusLabel: "Archived",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    tags: [
      "apparel",
      "headwear",
      "lifestyle",
      "summer",
      "event",
      "fmaTsika",
      "fmaMaxwell",
      "leadership",
      "classics",
      "freeEnterprise",
      "Conference",
      "Networking",
      "Professional",
      "Casual",
      "Outdoor",
      "Brand",
      "Limited Edition",
      "Popular",
    ],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_3",
    variationIds: ["var_3"],
    variations: [{ id: "var_3", color: "Navy", sizes: ["One Size Fits All"] }],
    stock: 0,
    image: "/figma-products/hat_black_1.jpg",
    createdAt: "2024-11-09T08:00:00Z",
    updatedAt: "2025-03-15T16:42:00Z",
  },
  {
    id: "prd_1004",
    netsuiteSku: "BK-15LAWS",
    netsuiteTitle: "15 Invaluable Laws of Growth",
    sku: "BK-15LAWS",
    name: "The 15 Invaluable Laws of Growth",
    description: "Leadership book by John C. Maxwell.",
    pricing: {
      lastPurchaseCents: 1965,
      premierMemberCents: 1700,
      retailCents: 1965,
    },
    currency: "USD",
    status: "in_review",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Literature",
    language: "English",
    availability: "available",
    productType: "Book",
    statusLabel: "In Review",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    author: "John C. Maxwell",
    tags: ["Classics", "Maxwell", "Leadership Summit"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_4",
    variationIds: [],
    stock: 220,
    image: "/figma-products/book_1.jpg",
    createdAt: "2024-09-01T08:00:00Z",
    updatedAt: "2025-05-10T16:42:00Z",
  },
  {
    id: "prd_1005",
    netsuiteSku: "BK-21LAWS",
    netsuiteTitle: "21 Irrefutable Laws of Leadership",
    sku: "BK-21LAWS",
    name: "The 21 Irrefutable Laws of Leadership",
    description: "Bestselling leadership classic by John C. Maxwell.",
    pricing: {
      lastPurchaseCents: 2200,
      premierMemberCents: 1950,
      retailCents: 2200,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Literature",
    language: "English",
    availability: "available",
    productType: "Book",
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    author: "John C. Maxwell",
    tags: ["Classics", "Maxwell", "Leadership Summit"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_5",
    variationIds: [],
    stock: 175,
    image: "/figma-products/book_2.jpg",
    createdAt: "2024-08-15T10:00:00Z",
    updatedAt: "2025-04-22T11:30:00Z",
  },
  {
    id: "prd_1006",
    netsuiteSku: "BK-TSIKA01",
    netsuiteTitle: "Tsika: Honoring the Founders",
    sku: "BK-TSIKA01",
    name: "Tsika: Honoring the Founders",
    description: "Foundational Tsika teachings.",
    pricing: {
      lastPurchaseCents: 1800,
      premierMemberCents: 1600,
      retailCents: 1800,
    },
    currency: "USD",
    status: "draft",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Literature",
    language: "English",
    availability: "available",
    productType: "Book",
    statusLabel: "Draft",
    audiencePinCodes: ["IBO", "PLA"],
    author: "Orrin Woodward",
    tags: ["Tsika", "Family Reunion"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_6",
    variationIds: [],
    stock: 92,
    image: "/figma-products/book_3.jpg",
    createdAt: "2024-10-12T09:00:00Z",
    updatedAt: "2025-03-30T14:00:00Z",
  },
  {
    id: "prd_1007",
    netsuiteSku: "WWG-CAP-BLU",
    netsuiteTitle: "Mesh Cap (Blue)",
    sku: "WWG-CAP-BLU",
    name: "WWG Mesh Cap",
    description: "Breathable mesh cap with WWG logo.",
    pricing: {
      lastPurchaseCents: 1500,
      premierMemberCents: 1300,
      retailCents: 1500,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Clothing",
    language: "English",
    availability: "available",
    productType: "Clothing",
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA", "EME"],
    tags: ["apparel", "headwear", "summer"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_7",
    variationIds: ["var_b1", "var_b2"],
    variations: [
      { id: "var_b1", color: "Blue", sizes: ["One Size Fits All"] },
      { id: "var_b2", color: "Black", sizes: ["One Size Fits All"] },
    ],
    stock: 320,
    image: "/figma-products/hat_blue_1.jpg",
    createdAt: "2024-12-01T08:00:00Z",
    updatedAt: "2025-05-15T16:00:00Z",
  },
  {
    id: "prd_1008",
    netsuiteSku: "WWG-LS-RED",
    netsuiteTitle: "WWG Long Sleeve Shirt",
    sku: "WWG-LS-RED",
    name: "WWG Long Sleeve Shirt",
    description: "Long sleeve shirt available in multiple colors.",
    pricing: {
      lastPurchaseCents: 1965,
      premierMemberCents: 1965,
      retailCents: 1965,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Clothing",
    language: "English",
    availability: "available",
    productType: "Clothing",
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    tags: ["apparel", "shirts", "longsleeve"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_8",
    variationIds: ["var_s1", "var_s2", "var_s3", "var_s4"],
    variations: [
      {
        id: "var_s1",
        color: "Red",
        sizes: ["S", "M", "L", "XL", "XXL", "XXXL"],
      },
      {
        id: "var_s2",
        color: "Blue",
        sizes: ["S", "M", "L", "XL", "XXL", "XXXL"],
      },
      {
        id: "var_s3",
        color: "Black",
        sizes: ["S", "M", "L", "XL", "XXL", "XXXL"],
      },
      {
        id: "var_s4",
        color: "White",
        sizes: ["S", "M", "L", "XL", "XXL", "XXXL"],
      },
    ],
    stock: 410,
    image: "/figma-products/shirt_2.jpg",
    createdAt: "2024-11-04T08:00:00Z",
    updatedAt: "2025-05-20T10:00:00Z",
  },
  {
    id: "prd_1009",
    netsuiteSku: "WWG-PEN-BLK",
    netsuiteTitle: "WWG Branded Pen",
    sku: "WWG-PEN-BLK",
    name: "WWG Branded Pen",
    description: "Premium ballpoint pen with WWG logo.",
    pricing: {
      lastPurchaseCents: 800,
      premierMemberCents: 700,
      retailCents: 800,
    },
    currency: "USD",
    status: "published",
    type: "WWG",
    source: "wwg",
    version: 1,
    category: "Accessories",
    language: "English",
    availability: "discontinued",
    productType: "Accessories",
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA"],
    tags: ["accessories", "stationery"],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: "med_9",
    variationIds: [],
    stock: 500,
    image: "/figma-products/pen_1.jpg",
    createdAt: "2025-01-20T08:00:00Z",
    updatedAt: "2025-05-25T09:00:00Z",
  },
];

// --- Date spread (test fixtures) -------------------------------------------
// Give the seed catalog a spread of created/updated dates so date sorting is
// easy to verify in dev/QA. Deterministic (index-derived) so the order is
// stable between page loads. Thrown away with the mock layer.
const DAY_MS = 24 * 60 * 60 * 1000;
const SEED_DATE_BASE = new Date("2024-03-01T00:00:00Z").getTime();
seedProducts.forEach((p, i) => {
  const createdOffset = (i * 47 + 13) % 430; // ~14 months of spread
  const created = new Date(SEED_DATE_BASE + createdOffset * DAY_MS);
  const updated = new Date(created.getTime() + ((i * 19 + 5) % 90) * DAY_MS);
  p.createdAt = created.toISOString();
  p.updatedAt = updated.toISOString();
  // Give the seed catalog audience membership codes so the "Filter by
  // Membership" section returns results in dev/QA. Deterministic for stable
  // ordering; thrown away with the mock layer.
  if (!Array.isArray(p.audienceMembershipCodes)) {
    p.audienceMembershipCodes =
      i % 3 === 0 ? ["C", "P"] : i % 3 === 1 ? ["C"] : ["P"];
  }
});

// --- Pagination test fixtures ----------------------------------------------
// Extra catalog items generated so the Store grid and the Order Management
// "Add to Cart" catalog have enough products to exercise pagination. They are
// prefixed with "Z" and given older dates than the real seed items so they
// sort to the end (by name) and the bottom (by date) for convenience. Thrown
// away with the rest of the mock layer once the real backend lands.
const FILLER_DEFS = [
  {
    name: "WWG Performance Polo",
    category: "Clothing",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 3200,
  },
  { name: "WWG Snapback Cap", category: "Clothing", type: "WWG", price: 2400 },
  {
    name: "WWG Hooded Sweatshirt",
    category: "Clothing",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 4800,
  },
  {
    name: "WWG Insulated Tumbler",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 2900,
  },
  {
    name: "WWG Leather Journal",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 2100,
  },
  {
    name: "WWG Canvas Tote",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 1800,
  },
  {
    name: "WWG Enamel Pin Set",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 1200,
  },
  {
    name: "WWG Sticker Pack",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 600,
  },
  {
    name: "Leadership Audio Series Vol. 2",
    category: "Media",
    type: "Brand",
    source: "wwg",
    version: 1,
    price: 3500,
  },
  {
    name: "Leadership Audio Series Vol. 3",
    category: "Media",
    type: "Brand",
    source: "wwg",
    version: 1,
    price: 3500,
  },
  {
    name: "Family Reunion 2026 Tee",
    category: "Clothing",
    type: "Event",
    source: "wwg",
    version: 1,
    price: 2200,
  },
  {
    name: "Family Reunion 2026 Lanyard",
    category: "Accessories",
    type: "Event",
    source: "wwg",
    version: 1,
    price: 900,
  },
  {
    name: "Spring Conference Workbook",
    category: "Media",
    type: "Event",
    source: "wwg",
    version: 1,
    price: 1500,
  },
  {
    name: "WWG Travel Backpack",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 5400,
  },
  {
    name: "WWG Water Bottle",
    category: "Accessories",
    type: "WWG",
    source: "wwg",
    version: 1,
    price: 1700,
  },
  { name: "WWG Beanie", category: "Clothing", type: "WWG", price: 1900 },
];

const fillerProducts = FILLER_DEFS.map((def, i) => {
  const n = 1010 + i;
  const displayName = `Z ${def.name}`;
  const slug = def.name
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .toUpperCase()
    .slice(0, 16);
  // All filler items predate the real catalog so they sort to the bottom by
  // date. Spread across early 2023 so date sorting still has some variety.
  const fillerBase = new Date("2023-01-01T00:00:00Z").getTime();
  const created = new Date(fillerBase + i * 6 * DAY_MS);
  const updated = new Date(created.getTime() + ((i * 11 + 3) % 40) * DAY_MS);
  return {
    id: `prd_${n}`,
    netsuiteSku: `WWG-${slug}`,
    netsuiteTitle: displayName,
    sku: `WWG-${slug}`,
    name: displayName,
    description: `${def.name} — sample catalog item for pagination testing.`,
    pricing: {
      lastPurchaseCents: def.price,
      premierMemberCents: Math.round(def.price * 0.9),
      retailCents: def.price,
    },
    currency: "USD",
    status: "published",
    type: def.type,
    source: "wwg",
    category: def.category,
    language: "English",
    availability: "available",
    version: 1,
    productType: def.category,
    statusLabel: "Published",
    audiencePinCodes: ["IBO", "PLA", "EME", "DIA"],
    audienceMembershipCodes: i % 2 === 0 ? ["C", "P"] : ["C"],
    tags: [def.category.toLowerCase()],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: `med_${n}`,
    variationIds: [],
    stock: 100 + i * 7,
    image: "/figma-products/pen_1.jpg",
    createdAt: created.toISOString(),
    updatedAt: updated.toISOString(),
  };
});

seedProducts.push(...fillerProducts);

// --- Bulk pagination fixtures ----------------------------------------------
// A larger block of generated items so the Store grid and Order Management
// catalog have enough products (100+) to exercise pagination windowing (the
// 5-page window + leading/trailing ellipses) without hand-authoring rows.
// Like the filler items above they are "Z"-prefixed with older dates so they
// sort to the end, and they vary across source/category/pin/membership so the
// source, permission, and OR/AND filters are all testable. Thrown away with
// the mock layer once the real backend lands.
const BULK_COUNT = 90;
const BULK_TYPES = ["WWG", "Brand", "Event", "3rd Party"];
const BULK_CATEGORIES = [
  "Clothing",
  "Accessories",
  "Media",
  "Literature",
  "Drinkware",
];
const BULK_PINS = ["IBO", "PLA", "EME", "DIA"];
const BULK_MEMBERSHIPS = ["C", "P"];
const BULK_DATE_BASE = new Date("2022-06-01T00:00:00Z").getTime();

const bulkProducts = Array.from({ length: BULK_COUNT }, (_, i) => {
  const n = 1100 + i;
  const type = BULK_TYPES[i % BULK_TYPES.length];
  const category = BULK_CATEGORIES[i % BULK_CATEGORIES.length];
  const displayName = `Z Sample Product ${String(i + 1).padStart(3, "0")}`;
  const created = new Date(BULK_DATE_BASE + i * 3 * DAY_MS);
  const updated = new Date(created.getTime() + ((i * 7 + 2) % 30) * DAY_MS);
  // Vary the audience so permission filters (and their OR/AND toggle) have a
  // mix of single- and multi-tier items to match against.
  const pins = BULK_PINS.slice(0, 1 + (i % BULK_PINS.length));
  const memberships = BULK_MEMBERSHIPS.slice(
    0,
    1 + (i % BULK_MEMBERSHIPS.length)
  );
  const price = 500 + ((i * 137) % 6000);
  return {
    id: `prd_${n}`,
    netsuiteSku: `WWG-BULK-${n}`,
    netsuiteTitle: displayName,
    sku: `WWG-BULK-${n}`,
    name: displayName,
    description: `Sample catalog item #${i + 1} for pagination testing.`,
    pricing: {
      lastPurchaseCents: price,
      premierMemberCents: Math.round(price * 0.9),
      retailCents: price,
    },
    currency: "USD",
    status: "published",
    type,
    category,
    language: "English",
    availability: "available",
    productType: category,
    statusLabel: "Published",
    audiencePinCodes: pins,
    audienceMembershipCodes: memberships,
    tags: [category.toLowerCase()],
    audienceGroupIds: ["aud_all"],
    primaryMediaId: `med_${n}`,
    variationIds: [],
    stock: 50 + i,
    image: "/figma-products/pen_1.jpg",
    createdAt: created.toISOString(),
    updatedAt: updated.toISOString(),
  };
});

seedProducts.push(...bulkProducts);

// --- Mock persistence layer -------------------------------------------------
// The mock "DB" is an in-memory array. To let edits survive a hard browser
// refresh (so the app behaves like a real backend during development/QA), we
// hydrate from localStorage on load and provide saveProducts() for the API
// namespace to call after each mutation. Clear the key (or localStorage) to
// reset back to seed data.
//
// Data URLs (from image uploads) are stored in separate per-asset keys so they
// don't bloat the products JSON and cause QuotaExceededError on save.
const STORAGE_KEY = "wwg_mock_products_v5";
const MEDIA_KEY_PREFIX = "wwg_media_";

function loadMediaUrl(id) {
  try {
    if (id && typeof window !== "undefined" && window.localStorage) {
      return window.localStorage.getItem(MEDIA_KEY_PREFIX + id) || null;
    }
  } catch (err) {
    // blocked
  }
  return null;
}

/**
 * Produce a copy of the product list with data: URLs stripped out, and collect
 * those data URLs (keyed by asset id) so the caller can persist them to their
 * own localStorage entries. Nothing is written here — separating "collect" from
 * "write" lets saveProducts() write the small products JSON FIRST (freeing any
 * space held by a previously bloated value) before writing the large media
 * blobs, which avoids spurious QuotaExceededErrors.
 */
function collectAndStrip(productList) {
  const media = {};
  const stripped = productList.map((p) => {
    const s = { ...p };
    if (s.thumbnailUrl && s.thumbnailUrl.startsWith("data:")) {
      if (s.thumbnailId) media[s.thumbnailId] = s.thumbnailUrl;
      s.thumbnailUrl = null;
      s.image = null;
    }
    if (Array.isArray(s.productImages)) {
      s.productImages = s.productImages.map((img) => {
        if (img && img.url && img.url.startsWith("data:")) {
          if (img.id) media[img.id] = img.url;
          return { ...img, url: null };
        }
        return img;
      });
    }
    return s;
  });
  return { stripped, media };
}

/** Set of every media asset id still referenced by an in-memory product. */
function referencedMediaIds(productList) {
  const ids = new Set();
  productList.forEach((p) => {
    if (p.thumbnailId) ids.add(p.thumbnailId);
    if (Array.isArray(p.productImages)) {
      p.productImages.forEach((img) => img && img.id && ids.add(img.id));
    }
  });
  return ids;
}

/** Delete any wwg_media_* keys whose asset id is no longer referenced. */
function pruneOrphanMedia(referenced) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    const ls = window.localStorage;
    const toRemove = [];
    for (let i = 0; i < ls.length; i += 1) {
      const key = ls.key(i);
      if (key && key.startsWith(MEDIA_KEY_PREFIX)) {
        const id = key.slice(MEDIA_KEY_PREFIX.length);
        if (!referenced.has(id)) toRemove.push(key);
      }
    }
    toRemove.forEach((key) => ls.removeItem(key));
  } catch (err) {
    // best-effort cleanup
  }
}

/** Re-hydrate data: URLs from their individual localStorage keys. */
function rehydrateDataUrls(productList) {
  return productList.map((p) => {
    const h = { ...p };
    if (!h.thumbnailUrl && h.thumbnailId) {
      const url = loadMediaUrl(h.thumbnailId);
      if (url) {
        h.thumbnailUrl = url;
        h.image = url;
      }
    }
    if (Array.isArray(h.productImages)) {
      h.productImages = h.productImages.map((img) => {
        if (img && !img.url && img.id) {
          const url = loadMediaUrl(img.id);
          if (url) return { ...img, url };
        }
        return img;
      });
    }
    return h;
  });
}

function loadProducts() {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length)
          return rehydrateDataUrls(parsed);
      }
    }
  } catch (err) {
    // Corrupt/blocked storage — fall through to seed data.
  }
  return JSON.parse(JSON.stringify(seedProducts));
}

const products = loadProducts();

export function saveProducts() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    const ls = window.localStorage;
    const { stripped, media } = collectAndStrip(products);

    // 1. Write the small (stripped) products JSON FIRST. This overwrites any
    //    previously bloated value and frees space before we store media blobs.
    try {
      ls.setItem(STORAGE_KEY, JSON.stringify(stripped));
    } catch (err) {
      // Even the stripped JSON overflowed — nothing more we can do here.
    }

    // 2. Drop media keys that no longer belong to any product (prevents the
    //    quota filling up with dead images from earlier upload attempts).
    const referenced = referencedMediaIds(products);
    pruneOrphanMedia(referenced);

    // 3. Persist each media asset in its own key. On quota, prune orphans and
    //    retry once so a self-inflicted full store can recover.
    Object.keys(media).forEach((id) => {
      try {
        ls.setItem(MEDIA_KEY_PREFIX + id, media[id]);
      } catch (err) {
        pruneOrphanMedia(referenced);
        try {
          ls.setItem(MEDIA_KEY_PREFIX + id, media[id]);
        } catch (err2) {
          // Genuinely out of room — the in-memory copy remains the source of truth.
        }
      }
    });
  } catch (err) {
    // Storage blocked entirely — keep the in-memory copy as source of truth.
  }
}

export default products;

// --- Tag normalization -----------------------------------------------------
// Tags are free-form but normalized to a canonical form so "Outdoor", "outdoor"
// and " outdoor  " never split into separate tags: lowercase, strip anything
// that isn't a lowercase letter / number / space, collapse internal runs of
// whitespace, and trim. Applied on write (create/update) and whenever tags are
// surfaced for display or filtering.
export function normalizeTag(raw) {
  return String(raw == null ? "" : raw)
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function normalizeTags(list = []) {
  const seen = new Set();
  const out = [];
  (Array.isArray(list) ? list : [list]).forEach((t) => {
    const n = normalizeTag(t);
    if (n && !seen.has(n)) {
      seen.add(n);
      out.push(n);
    }
  });
  return out;
}

// --- Purchase events (popularity test fixtures) ----------------------------
// Mock "order line" events used to drive popularity/trending sorting. Each
// event is { productId, at (ISO), qty }. Generated relative to the current time
// at load so the "Last 7 / 30 days" windows are always meaningful. Some items
// get a recent spike (trending) while others have steady all-time demand, so
// the three windows produce visibly different orderings. This is throwaway
// scaffolding — the real feed comes from the orders/NetSuite backend later.
function buildPurchaseEvents(items) {
  const events = [];
  const now = Date.now();
  items.forEach((p, i) => {
    // Baseline demand spread across the last ~8–60 days (drives "all time").
    const baseline = 1 + ((i * 13 + 5) % 9);
    for (let k = 0; k < baseline; k += 1) {
      const daysAgo = 8 + ((i * 3 + k * 7) % 52);
      events.push({
        productId: p.id,
        at: new Date(now - daysAgo * DAY_MS).toISOString(),
        qty: 1 + ((i + k) % 3),
      });
    }
    // Recent spike within the last 7 days (drives "Last 7 days"). Every 4th
    // item trends hard recently so the short window reranks noticeably.
    const recent = i % 4 === 0 ? 8 + (i % 5) : i % 3 === 0 ? 4 : 1;
    for (let k = 0; k < recent; k += 1) {
      const daysAgo = (i + k) % 7;
      events.push({
        productId: p.id,
        at: new Date(now - daysAgo * DAY_MS).toISOString(),
        qty: 1 + ((i + k) % 4),
      });
    }
  });
  return events;
}

export const purchaseEvents = buildPurchaseEvents(products);

/**
 * Tags present in the catalog, normalized and ordered by frequency (most-used
 * first) so the UI can surface just the top N as quick filters. Backs the
 * dynamic "Filter by Tag" options.
 * @returns {string[]}
 */
export function listProductTags() {
  const counts = new Map();
  products.forEach((p) =>
    normalizeTags(p.tags || []).forEach((t) =>
      counts.set(t, (counts.get(t) || 0) + 1)
    )
  );
  // Most frequent first; alphabetical tie-break for stability.
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .map(([tag]) => tag);
}

/**
 * Distinct product types present in the catalog (the value shown in the card's
 * "Type" column). Backs the dynamic "Filter by Type" options.
 * @returns {string[]}
 */
export function listProductTypes() {
  const set = new Set();
  products.forEach((p) => {
    const t = p.productType || p.category;
    if (t) set.add(t);
  });
  return Array.from(set).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
}

/**
 * NetSuite SKU search mock — simulates the catalog of SKUs that exist in
 * NetSuite but haven't been imported into Mongo yet. Add Product flow searches
 * this list.
 */
export const netsuiteSearchResults = [
  { sku: "BK187", title: "White WWG Mesh Hat" },
  { sku: "BK188", title: "WWG Long Sleeve Shirt" },
  { sku: "BK189", title: "Black WWG Flatbrim Hat" },
  { sku: "BK190", title: "The 21 Irrefutable Laws of Leadership" },
  { sku: "BK191", title: "WWG Travel Mug" },
  { sku: "BK192", title: "Family Reunion 2026 Tee" },
];
